import classNames from 'classnames/bind';
import Spinner, { SpinnerSize } from '../spinner/spinner';
import styles from './table.module.scss';

const classesContext = classNames.bind(styles);

interface TableSpinnerProps {
  className?: string;
}

export default function TableSpinner({ className }: TableSpinnerProps): JSX.Element {
  return (
    <div className={classesContext(['table_spinner', className])}>
      <Spinner size={SpinnerSize.LARGE} />
    </div>
  );
}
